import React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import { down } from 'styled-breakpoints';

import ProgressBar from './progress-bar';
import Header from './header';

function Layout(props) {
  const { group } = Redux.useSelector(state => state);
  const showProgressBar = props.route.label !== 'Submit';

  return (
    <Container showProgressBar={showProgressBar}>
      <div className="header">
        <Header
          accountLogo={group.accountLogo}
          groupLogo={group.logo}
          groupSlug={group.slug}
        />
      </div>
      <div className="content">{props.children}</div>

      <div className="footer">
        {showProgressBar && (
          <ProgressBar route={props.route} routes={props.routes} />
        )}
      </div>
    </Container>
  );
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  display: -ms-grid;
  grid-template-rows: ${({ theme }) =>
    `${theme.header} ${theme.content} ${theme.footer}`};
  -ms-grid-rows: ${({ theme }) =>
    `${theme.header} ${theme.content} ${theme.footer}`};
  grid-template-columns: 100%;
  -ms-grid-columns: 100%;
  background-color: ${props => props.theme.background};
  font-size: 16px;
  font-family: ${props => props.theme.baseFontFamily};

  ${down('md')} {
    height: 90%;
  }

  .header {
    grid-row: 1;
    -ms-grid-row: 1;
    padding: 10px;
    border-bottom: ${props => `1px solid ${props.theme.border}`};
  }
  .content {
    grid-row: 2;
    -ms-grid-row: 2;
    height: 100%;
    display: flex;
    overflow: auto;
  }
  .footer {
    grid-row: 3;
    -ms-grid-row: 3;
    padding: 20px;

    ${props => {
      if (props.showProgressBar) {
        return `
          border-top: 1px solid ${props.theme.border};
        `;
      }
    }}
  }
`;

export default Layout;
